import { render, staticRenderFns } from "./InterviewFreeText.vue?vue&type=template&id=5444d7ea&scoped=true&"
import script from "./InterviewFreeText.vue?vue&type=script&lang=js&"
export * from "./InterviewFreeText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5444d7ea",
  null
  
)

export default component.exports